import { ThemeColor } from '@coin/shared/core/util-models';
import { ListViewFilterTagType } from '@coin/shared/core/util-enums';
import { ListViewFilterTag } from '@coin/shared/core/util-models';

export const ACTIVITY_STREAM_TAGS: ListViewFilterTag[] = [
  {
    title: 'activity-stream.event-type',
    icon: 'event',
    color: 'purple' as ThemeColor,
    filterKey: 'itemType',
    type: ListViewFilterTagType.DropdownWithoutTotalCount,
    isMultiSelect: true,
    subFilters: []
  },
  {
    title: 'activity-stream.event-by',
    icon: 'group',
    color: 'lightgrey' as ThemeColor,
    filterKey: 'eventBy',
    type: ListViewFilterTagType.Input,
    subFilters: []
  },
  {
    title: 'activity-stream.date',
    icon: 'schedule',
    color: 'petrol' as ThemeColor,
    filterKey: 'eventAt',
    type: ListViewFilterTagType.Date,
    subFilters: []
  }
];
